import { render, staticRenderFns } from "./EventPrice.vue?vue&type=template&id=4ecf3bd4&lang=pug"
import script from "./EventPrice.vue?vue&type=script&lang=js"
export * from "./EventPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports